import React, { useState } from 'react';
import "../components/styles/ManualPage.css";

// 영상 URL 배열
const videos = [
    { id: 'x5x6r5', title: 'N사 DB 추출기 사용법', url: 'https://www.youtube.com/watch?v=7qxdT7_4flw', thumbnail: '/images/manual_thumbnail_2' },
    { id: 'a1b2c3', title: 'N사 밴드 글쓰기 사용법', url: 'https://www.youtube.com/watch?v=KOu1OMslBrQ' },
    { id: 'd4e5f6', title: '인별그램 크롤러 사용법', url: 'https://www.youtube.com/watch?v=fZXOTQeEvGI' },
    // { id: 'y7y8z9', title: '기능별 사용 설명서', url: 'https://youtu.be/I0AAS0rn944?si=zNs25CZ5USu4unUr' },
    // { id: 'a1b2c3', title: '자주 묻는 질문 답변', url: 'https://youtu.be/o-tgQzqlwkQ?si=H8tc5nOplgmdGaqW' },
];

// 유튜브 URL에서 영상ID 추출 함수
const getYoutubeId = (url) => {
    const regExp = /(?:https?:\/\/)?(?:www\.)?youtu(?:\.be\/|be\.com\/(?:watch\?v=|embed\/|v\/|shorts\/|user\/.*?#!v=))([^&?\/\s]{11})/;
    const match = url.match(regExp);
    return match ? match[1] : null;
};

const ManualPage = () => {
    const [selectedVideo, setSelectedVideo] = useState(null);

    const openModal = (videoUrl) => setSelectedVideo(videoUrl);
    const closeModal = () => setSelectedVideo(null);

    // 새로 접속 시 맨 위로 이동
    window.scrollTo(0, 0);

    return (
        <div className="manual-page">
            {/*<h1 className="manual-title">고객지원 - 매뉴얼</h1>*/}
            {/*<p className="manual-subtitle">소프트캣 프로그램 매뉴얼</p>*/}

            <div className="video-thumbnail-container">
                <img src="images/manual_thumbnail.png" alt="매뉴얼 썸네일" className="video-thumbnail" />
                {/*<button className="play-button">&#9658;</button> /!* ▶ 아이콘 *!/*/}
            </div>

            {/*<div className="manual-text-section">*/}
            {/*    <h2 className="manual-heading">사용자 매뉴얼</h2>*/}
            {/*    <p className="manual-description">*/}
            {/*        소프트캣 프로그램을 처음 사용하는 분들을 위한 매뉴얼입니다.<br />*/}
            {/*        기본 설치부터 사용 방법까지 단계별로 안내합니다.*/}
            {/*    </p>*/}
            {/*</div>*/}

            <div className="video-grid">
                {videos.map((video) => {
                    const videoId = getYoutubeId(video.url);
                    const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
                    return (
                        <div key={video.id} className="video-card" onClick={() => openModal(video.url)}>
                            <img src={thumbnailUrl} alt={video.title} className="video-card-thumbnail" />
                            <h3 className="video-card-title">{video.title}</h3>
                        </div>
                    );
                })}
            </div>

            {selectedVideo && (
                <div className="modal-overlay" onClick={closeModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="modal-close" onClick={closeModal}>&times;</button>
                        <iframe
                            src={`https://www.youtube.com/embed/${getYoutubeId(selectedVideo)}`}
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            className="youtube-video"
                        ></iframe>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ManualPage;
